module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms17e-detail2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row margin-b-5"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label align-right"
  }, [_vm._v(_vm._s(_vm.labels['HRAP32EC2']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.searchIndex.year))])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label align-right"
  }, [_vm._v(_vm._s(_vm.labels['HRAP32EC2']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.searchIndex.numtime))])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-b-5"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label align-right"
  }, [_vm._v(_vm._s(_vm.labels['HRAP32EC2']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.dataHeader.codempid) + " - " + _vm._s(_vm.dataHeader.desc_codempid))])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-b-5"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label align-right"
  }, [_vm._v(_vm._s(_vm.labels['HRAP32EC2']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.dataHeader.codcomp) + " - " + _vm._s(_vm.dataHeader.desc_codcomp))])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-b-5"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label align-right"
  }, [_vm._v(_vm._s(_vm.labels['HRAP32EC2']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.dataHeader.codpos) + " - " + _vm._s(_vm.dataHeader.desc_codpos))])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-b-5"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label align-right"
  }, [_vm._v(_vm._s(_vm.labels['HRAP32EP1']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail.detail.kpino))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label align-right"
  }, [_vm._v(_vm._s(_vm.labels['HRAP32EP1']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 margin-b-5"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.detail.kpiitem),
      expression: "detail.detail.kpiitem"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:500'),
      expression: "'required|max:500'"
    }],
    staticClass: "detail-text input-text width-100",
    class: {
      'form-control': true, 'input-error': _vm.errors.has('kpiitem')
    },
    attrs: {
      "name": "kpiitem",
      "maxlength": "500"
    },
    domProps: {
      "value": (_vm.detail.detail.kpiitem)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.detail, "kpiitem", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('kpiitem')),
      expression: "errors.has('kpiitem')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('kpiitem')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(500)))])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label align-right"
  }, [_vm._v(_vm._s(_vm.labels['HRAP32EP1']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.detail.target),
      expression: "detail.detail.target"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:200'),
      expression: "'max:200'"
    }],
    staticClass: "detail-text input-text width-100",
    attrs: {
      "maxlength": "200",
      "data-vv-name": "target",
      "has-error": _vm.errors.has('target')
    },
    domProps: {
      "value": (_vm.detail.detail.target)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.detail, "target", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('target')),
      expression: "errors.has('target')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('target')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(200)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label align-right"
  }, [_vm._v(_vm._s(_vm.labels['HRAP32EP1']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 margin-b-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.detail.kpiwgt),
      expression: "detail.detail.kpiwgt"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|between:0,99|max:6'),
      expression: "'required|between:0,99|max:6'"
    }],
    class: {
      'form-control': true, 'input-error': _vm.errors.has('kpiwgt')
    },
    attrs: {
      "type": "text",
      "maxlength": "6",
      "name": "kpiwgt"
    },
    domProps: {
      "value": (_vm.detail.detail.kpiwgt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.detail, "kpiwgt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('kpiwgt')),
      expression: "errors.has('kpiwgt')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('kpiwgt')))])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label align-right"
  }, [_vm._v(_vm._s(_vm.labels['HRAP32EP1']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('date_format:DD/MM/YYYY'),
      expression: "'date_format:DD/MM/YYYY'"
    }],
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "dtetarg",
      "has-error": _vm.errors.has('dtetarg')
    },
    model: {
      value: (_vm.detail.detail.dtetarg),
      callback: function($$v) {
        _vm.$set(_vm.detail.detail, "dtetarg", $$v)
      },
      expression: "detail.detail.dtetarg"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dtetarg')),
      expression: "errors.has('dtetarg')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dtetarg')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label align-right"
  }, [_vm._v(_vm._s(_vm.labels['HRAP32EP1']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('hrms-dropdown', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.dropdowns.mtrunit[_vm.nowLang],
      "data-vv-value-path": "inputValue",
      "data-vv-name": "mtrunit",
      "has-error": _vm.errors.has('mtrunit')
    },
    model: {
      value: (_vm.detail.detail.mtrunit),
      callback: function($$v) {
        _vm.$set(_vm.detail.detail, "mtrunit", $$v)
      },
      expression: "detail.detail.mtrunit"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mtrunit')),
      expression: "errors.has('mtrunit')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('mtrunit')))])], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label align-right"
  }, [_vm._v(_vm._s(_vm.labels['HRAP32EP1']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.detail.mtrvalue),
      expression: "detail.detail.mtrvalue"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:14'),
      expression: "'required|max:14'"
    }],
    staticClass: "detail-text input-text width-100",
    class: {
      'form-control': true, 'input-error': _vm.errors.has('mtrvalue')
    },
    attrs: {
      "type": "number",
      "maxlength": "14",
      "name": "mtrvalue"
    },
    domProps: {
      "value": (_vm.detail.detail.mtrvalue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.detail, "mtrvalue", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mtrvalue')),
      expression: "errors.has('mtrvalue')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('mtrvalue')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details2_tab1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRAP32EP1']['130']) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "details2_tab1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('hrms-table', {
    ref: "detail2Tab1Table",
    attrs: {
      "columns": _vm.detail2Tab1Table,
      "data": _vm.detail.tab1,
      "addInlineEventBool": true,
      "editInlineEventBool": true,
      "deleteInlineEventBool": true,
      "saveInlineEvent": _vm.callSaveTab1,
      "saveInlineBtnDisp": false,
      "deleteInlineBtnDisp": false,
      "indexDisp": false
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details2_tab2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRAP32EP2']['10']) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "details2_tab2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('hrms-table', {
    ref: "detail2Tab2Table",
    attrs: {
      "columns": _vm.detail2Tab2Table,
      "maxRowspan": _vm.maxRowspan,
      "data": _vm.detail.tab2,
      "addInlineEventBool": true,
      "editInlineEventBool": true,
      "deleteInlineEventBool": true,
      "saveInlineEvent": _vm.callSaveTab2,
      "saveInlineBtnDisp": false,
      "deleteInlineBtnDisp": false,
      "indexDisp": false
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('detail1')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))]), _vm._v(" "), _c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button",
      "value": "Save"
    },
    on: {
      "click": function($event) {
        _vm.postDetail2()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30bc3f4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms17e/detail2.vue
// module id = 3668
// module chunks = 1